import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { ziruiProfile } from '../pages/ziruiProfileData';
import './ZiruiSpotlight.css';

const ZiruiSpotlight = () => {
  const { t } = useI18n();
  return (
    <section className="zirui-spotlight" aria-labelledby="zirui-spotlight-title">
      <div className="zirui-spotlight-inner">
        <Link to={ziruiProfile.path} className="zirui-spotlight-image">
          <img src={ziruiProfile.image} alt={t('profile.imageAlt')} width="1000" height="1000" loading="lazy" decoding="async" />
        </Link>
        <div className="zirui-spotlight-copy">
          <p className="zirui-eyebrow">{t('profile.eyebrow')}</p>
          <h2 id="zirui-spotlight-title">{t('profile.name')}</h2>
          <p className="zirui-role">{t('profile.role')}</p>
          <p>{t('profile.intro')}</p>
          <div className="zirui-actions">
            <a className="zirui-button" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer" data-analytics-target="home_zirui_website">
              {t('profile.visitWebsite')} <span aria-hidden="true">↗</span>
            </a>
            <Link className="zirui-text-link" to={ziruiProfile.path}>{t('profile.readStory')} <span aria-hidden="true">→</span></Link>
          </div>
          <a className="zirui-domain" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer">ziruiqiu.com</a>
        </div>
      </div>
    </section>
  );
};

export default ZiruiSpotlight;
